module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"permission":"Permission"},"et":{"permission":"Permission"},"ru":{"permission":"Permission"}}')
  delete Component.options._Ctor
}
